import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { Employee } from '../types/Employee';
import { salaryDeductionConverter } from '../converters/salaryDeductionConverter';
import { SalaryDeduction } from '../types/SalaryDeduction';
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from 'luxon';

export const createSalaryDeduction = async (employee: Employee, numDays: number, reason: string) => {
  let salaryDeduction: SalaryDeduction = {
    id: uuidv4(),
    idNumber: employee.idNumber,
    numDays: numDays,
    reason: reason,
    date: DateTime.now(),
    lastUpdate: DateTime.now()
  };

  const db = getFirestore();
  const docRef = doc(db, `Employees/${employee.idNumber}/SalaryDeductions/${salaryDeduction.id}`).withConverter(salaryDeductionConverter);
  await setDoc(docRef, salaryDeduction, { merge: true });
};
